import ExportIcon from '@mui/icons-material/Description'
import React from 'react'
import { Trans } from 'react-i18next'
import { i18n } from '../index/index'
import {
  ExportLink,
  IncentiveSalesProgress,
  Widget,
  WidgetContent,
  WidgetHeader,
  WidgetSubHeader,
} from './OldDashboardComponents'

type Props = {
  actual: number
  target: number
  lastUpdatedAt: string
  date: string
}

const DaySales = ({ actual, target, date, lastUpdatedAt }: Props) => (
  <Widget>
    <WidgetHeader>{i18n.t('oldDashboard.widget.daySales.title')}</WidgetHeader>
    <WidgetSubHeader>
      {lastUpdatedAt
        ? i18n.t('oldDashboard.widget.daySales.updatedAt', { lastUpdatedAt })
        : i18n.t('oldDashboard.widget.daySales.notUpdated')}
    </WidgetSubHeader>
    <WidgetContent>
      <IncentiveSalesProgress
        value={target ? Math.round((actual / target) * 100) : '-'}
        legend={
          <Trans
            i18nKey='oldDashboard.widget.daySales.legend'
            values={{ target: Math.round(target), actual: Math.round(actual) }}
            components={{ actual: <strong />, target: <strong /> }}
          />
        }
      />
    </WidgetContent>
    <ExportLink to={`/vuorokausijohtaminen/${date}`}>
      <ExportIcon />
    </ExportLink>
  </Widget>
)

export default DaySales
